import { render } from "./Recruitment.vue?vue&type=template&id=a01aeb64"
import script from "./Recruitment.vue?vue&type=script&lang=js"
export * from "./Recruitment.vue?vue&type=script&lang=js"

import "./Recruitment.vue?vue&type=style&index=0&id=a01aeb64&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__